<template>
  <div class="position-relative" id="examResultSingle">
    <neo-print-wrapper title="Exam Report">
      <a-spin :spinning="loading">
        <div class="row" v-if="classStudent.length != 0" style="font-size:15px">
          <div class="col-12">
            <b>{{ classStudent.first_name }} {{ classStudent.last_name }}</b>
            <p class="mb-2">
              Student code:
              <span class="font-weight-bold">{{
                studentData.student_code
              }}</span>
              | Class:
              <span class="font-weight-bold">{{
                examData.school_class.name
              }}</span>
              | Section:
              <span class="font-weight-bold">{{ examData.section.name }}</span>
              | Roll No:
              <span class="font-weight-bold">{{ studentData.roll_no }}</span>
            </p>
          </div>
        </div>
        <!-- Class I-X -->
        <!-- class-i to class x -->
        <div class="row" v-if="reportCardFormat == 1" :key="reportCardFormat">
          <div class="col-12">
            <vue-custom-scrollbar class="scroll-area">
              <!-- trail -->
              <table
                class="table table-sm table-sm-responsive table-bordered "
                v-if="getStudent_ExamDetails != 0"
              >
                <!-- top -->
                <tr>
                  <th></th>
                  <th :colspan="4" style="text-align: center">
                    X-Periodic Tests + Internal Assessment <br />
                    Marks Secured
                  </th>
                  <th style="text-align: center">
                    Y-1st & 2nd Term Test <br />
                    Marks Secured
                  </th>
                  <th></th>
                </tr>

                <!--  2nd row subject and Exam column-->
                <!-- if length =4 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th class="text-center" style="width:14.28%">SUBJECTs</th>
                  <th style="width:14.28%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:14.28%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length =4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th class="text-center" style="width:14.28%">SUBJECTs</th>
                  <th style="width:14.28%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:14.28%">2nd Term Test</th>
                  <th class="text-center" style="width:14.28%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th class="text-center" style="width:14.28%">SUBJECT</th>
                  <th style="width:14.28%"
                    class="text-center"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:14.28%">Int. Assess</th>
                  <th class="text-center" style="width:14.28%">2nd Term Test</th>
                  <th class="text-center" style="width:14.28%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th class="text-center" style="width:14.28%">SUBJECT</th>
                  <th style="width:14.28%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:14.28%">1st Term Test</th>
                  <th class="text-center" style="width:14.28%">Int. Assess</th>
                  <th class="text-center" style="width:14.28%">2nd Term Test</th>
                  <th class="text-center" style="width:14.28%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th class="text-center" style="width:14.28%">SUBJECT</th>
                  <th style="width:14.28%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:14.28%">2nd P/T</th>
                  <th class="text-center" style="width:14.28%">1st Term Test</th>
                  <th class="text-center" style="width:14.28%">Int. Assess</th>
                  <th class="text-center" style="width:14.28%">2nd Term Test</th>
                  <th class="text-center" style="width:14.28%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>

                <!-- passmark fullmark -->
                <!-- if length = 5 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:20 <br />
                    P.M:7
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th>
                    F.M:20 <br />
                    P.M:7
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:40 <br />
                    P.M:14
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th>
                    F.M:20 <br />
                    P.M:7
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>

                <!-- subject and mark row-->
                <!-- if length=5 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- ..0 mark. -->
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- ..0 mark. -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- 0  -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark score -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- 0  -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 mark. -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 mark. -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- 0  -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- 0  -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- Total -->
                <!-- if length=5 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- mark score column -->
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- mark score column -->
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column ">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...0.. -->
                  <th>
                    <div class="column ">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- PC/div -->
                <!-- if length=5 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <!-- final result coumn -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- </span> -->
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- Rank Division -->
                <!-- if length=5 -->
                <tr v-if="getStudent_ExamDetails.length == 5">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <!-- ...... data....... -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <!-- ...... NA....... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <!-- ...... data....... -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
              </table>

              <table class="table table-sm table-sm-responsive table-bordered" style="font-size:12px;margin:0px">
                <!-- Remarks -->
                <!-- heading -->
                <tr>
                  <th colspan="4">
                      <span style="font-size: 12px">Teachers Remark</span>
                  </th>
                  <!-- ...... data....... -->
                </tr>
                <!-- if length = 4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th
                    style="width: 25%"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th
                    style="width: 25%"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>

                  <th  style="width: 25%">
                    <span style="font-size: 12px">2nd T/T :......................</span>
                  </th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th
                     style="width: 25%"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                  <th  style="width: 25%"><span style="font-size: 12px">1st T/T :......................</span></th>
                  <th  style="width: 25%">
                    <span style="font-size: 12px">2nd T/T :......................</span>
                  </th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th
                     style="width: 25%"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                    <span style="font-size: 12px">2nd-P/T :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                    <span style="font-size: 12px">1st T/T :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                   <span style="font-size: 12px"> 2nd T/T :......................</span>
                  </th>
                </tr>
              </table>
              <br />
              <table class="table table-sm table-sm-responsive">
                  <!-- Top Exam row -->
                  <tr class="text-center">
                    <th style="width:33.33%"><span style="font-size: 12px">Teacher's signature</span></th>
                    <th style="width:33.33%"><span style="font-size: 12px">Parent's signature</span></th>
                    <th style="width:33.33%"><span style="font-size: 12px">Principal's signature</span></th>
                  </tr>
              </table>
              <b style="font-size: 11px"
                >N.B : Marks of final T/T is 100/2 = 50, so that we can
                calculate (X+Y) /2 as per board norm.</b
              >
            </vue-custom-scrollbar>
          </div>
        </div>
        <!-- Class-PRE to KG -->
        <div class="row" v-else>
          <div class="col-12">
            <vue-custom-scrollbar class="scroll-area">
              <!-- trail -->
              <table
                class="table table-sm table-sm-responsive table-bordered "
                v-if="getStudent_ExamDetails != 0"
              >
                <!-- top -->
                <tr>
                  <th></th>
                  <th :colspan="3" style="text-align: center">
                    X-Periodic Tests + Internal Assessment <br />
                    Marks Secured
                  </th>
                  <th style="text-align: center">
                    Y-1st & 2nd Term Test <br />
                    Marks Secured
                  </th>
                  <th></th>
                </tr>

                <!--  2nd row subject and Exam column-->
                <!-- if length = 4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th class="text-center" style="width:16.66%">SUBJECT</th>
                  <th style="width:16.66%"
                    class="text-center"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:16.66%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th class="text-center" style="width:16.66%">SUBJECT</th>
                  <th style="width:16.66%"
                    class="text-center"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:16.66%">2nd Term Test</th>
                  <th class="text-center" style="width:16.66%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th class="text-center" style="width:16.66%">SUBJECT</th>
                  <th style="width:16.66%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:16.66%">1st Term test</th>
                  <th class="text-center" style="width:16.66%">2nd Term Test</th>
                  <th class="text-center" style="width:16.66%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th class="text-center" style="width:16.66%">SUBJECT</th>
                  <th style="width:16.66%"
                    class="text-center"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    {{ data.exam.name }}
                  </th>
                  <th class="text-center" style="width:16.66%">2nd P/T</th>
                  <th class="text-center" style="width:16.66%">1st Term Test</th>
                  <th class="text-center" style="width:16.66%">2nd Term Test</th>
                  <th class="text-center" style="width:16.66%">
                    Final Result <br />
                    (X+Y)/2
                  </th>
                </tr>

                <!-- passmark fullmark -->
                <!-- if length = 4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th scope="col"></th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    F.M:{{ data.student_exam_marks[0].exam_full_mark }} <br />
                    P.M:{{ data.student_exam_marks[0].exam_pass_mark }}
                  </th>
                  <th>
                    F.M:40 <br />
                    P.M:14
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th>
                    F.M:50 <br />
                    P.M:17
                  </th>
                  <th></th>
                </tr>

                <!-- subject and mark row-->
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- final result mark score -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark score -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- 0 mark -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 mark. -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">{{ examSubject.subject.name }}</div>
                    </div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >
                        <span
                          :class="
                            getMarksColor(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          "
                        >
                          {{
                            getMarks(
                              data.student_exam_marks,
                              examSubject.subject.id
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </th>
                  <!-- 0  -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- ..0 . -->
                  <th scope="col">
                    <div
                      class="Row"
                      style="margin:auto"
                      v-for="(examSubject, index) in classSubjectList.all"
                      :key="index"
                    >
                      <div class="Column">NA</div>
                    </div>
                  </th>
                  <!-- final result mark -->
                  <th>
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="(examSubject, index) in classSubjectList.all"
                        :key="index"
                      >NA
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- Total -->
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ...0.. -->
                  <th>
                    <div class="column ">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...0.. -->
                  <th>
                    <div class="column ">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Score</div>
                  </th>
                  <!-- marks -->
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }}
                      </div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ..0... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        NA
                        <!-- {{ markscore.total_mark_score }} /
                        {{ markscore.total_exam_full_mark }} -->
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- PC/div -->
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <!-- final result coumn -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.mark_percentage }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.mark_percentage }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}%
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.mark_percentage }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Percentage</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{ markscore.mark_percentage }}
                      </div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- ...... NA....... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- final result coumn -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.mark_percentage }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>

                <!-- Rank Division -->
                <!-- if length=4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
                <!-- if length=1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th>
                    <div class="column" style="margin:auto">Rank/Div</div>
                  </th>
                  <th
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <!-- {{data}} -->
                    <div class="column">
                      <div
                        class="Row"
                        style="margin:auto"
                        v-for="markscore in data.student_declared_marks"
                        :key="markscore.subject_id"
                      >
                        {{
                          markscore.division == null
                            ? markscore.rank
                            : markscore.division
                        }}
                      </div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <div class="column">
                      <div class="Row" style="margin:auto">NA</div>
                    </div>
                  </th>
                  <!-- .....NA...... -->
                  <th>
                    <!-- {{data}} -->
                    <div class="column">
                      <div class="Row" style="margin:auto">
                        <!-- {{ markscore.class_rank }} -->NA
                      </div>
                    </div>
                  </th>
                </tr>
              </table>

              <table class="table table-sm table-sm-responsive table-bordered" style="font-size:12px;margin:0px">
                <!-- Remarks -->
                <!-- heading -->
                <tr>
                  <th colspan="4">
                      <span style="font-size: 12px">Teachers Remark</span>
                  </th>
                  <!-- ...... data....... -->
                </tr>
                <!-- if length = 4 -->
                <tr v-if="getStudent_ExamDetails.length == 4">
                  <th
                    style="width: 25%"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                </tr>
                <!-- if length = 3 -->
                <tr v-if="getStudent_ExamDetails.length == 3">
                  <th
                    style="width: 25%"
                    v-for="data in getStudent_ExamDetails"
                    :key="data.exam_id"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>

                  <th  style="width: 25%">
                    <span style="font-size: 12px">2nd T/T :......................</span>
                  </th>
                </tr>
                <!-- if length = 2 -->
                <tr v-if="getStudent_ExamDetails.length == 2">
                  <th
                     style="width: 25%"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                  <th  style="width: 25%"><span style="font-size: 12px">1st T/T :......................</span></th>
                  <th  style="width: 25%">
                    <span style="font-size: 12px">2nd T/T :......................</span>
                  </th>
                </tr>
                <!-- if length = 1 -->
                <tr v-if="getStudent_ExamDetails.length == 1">
                  <th
                     style="width: 25%"
                    v-for="(data, index) in getStudent_ExamDetails"
                    :key="index"
                  >
                    <span style="font-size: 12px">{{ data.exam.name }} :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                    <span style="font-size: 12px">2nd-P/T :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                    <span style="font-size: 12px">1st T/T :......................</span>
                  </th>
                  <th class="text-center"  style="width: 25%">
                   <span style="font-size: 12px"> 2nd T/T :......................</span>
                  </th>
                </tr>
              </table>
              <br>
              <table class="table table-sm table-sm-responsive">
                  <!-- Top Exam row -->
                  <tr style="font-size: 12px">
                    <th style="width: 50%"><span style="font-size: 12px">Teacher's signature</span></th>
                    <th style="width: 50%"><span style="font-size: 12px">Principal</span></th>
                  </tr>
              </table>
              <!-- <b style="font-size: 11px"
                >N.B : Marks of final T/T is 100/2 = 50, so that we can
                calculate (X+Y) /2 as per board norm.</b
              > -->
            </vue-custom-scrollbar>
          </div>
        </div>
      </a-spin>
      <div class="position-absolute neo-tr-5 d-print-none">
        <button
          type="button"
          class="btn btn-light btn-sm btn-with-addon"
          @click="print"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-printer" />
          </span>
          Print
        </button>
      </div>
    </neo-print-wrapper>
  </div>
</template>

<script>
// import { find } from 'lodash'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'

// import StudentExamRemarks from "../Remark/index";

export default {
  name: 'StudentMarksDisplaySingle',
  props: [
    'getStudent_ExamDetails',
    'studentData',
    'examData',
    'allExams',
    'reportsData',
    'remarksData',
    'allExamData',
    'reportCardFormat',
    'classId',
    'sessionId',
    'classSubjectList',
  ],
  components: {
    vueCustomScrollbar,
    // StudentExamRemarks,
    NeoPrintWrapper,
  },
  data: function() {
    return {
      loading: false,
      currentSubjectName: [],
      data: [],
      color: 'text-dark',
    }
  },
  computed: {
    examDetails: function() {
      return this.getStudent_ExamDetails
    },
    class_Id: function() {
      return this.classId
    },
    session_Id: function() {
      return this.sessionId
    },
    allExams_name: function() {
      return this.allExams.exam
    },
    allExamDatas: function() {
      return this.allExamData
    },
    classStudent: function() {
      return this.studentData.student
    },
    studentMarks: function() {
      return this.studentData.student_exam_mark
    },
  },
  watch: {
    classId: function(value) {
      return value
    },
    classSubjectList: function(val) {
      return val
    },
    sessionId: function(value) {
      return value
    },
    getStudent_ExamDetails: function(val) {
      return val
    },

    currentSubjectName: function(value) {
      return value
    },
  },
  methods: {
    getMarks(marksArray, subjeectId) {
      var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
      if (foundValue.length !== 0) {
        var newObj = Object.assign({}, ...foundValue)
        // console.log(newObj);
        if (newObj.is_absent === 1) {
          const absent = 'AB'
          return absent
        } else if (newObj.is_absent === 0) {
          // if grade is null
          if (newObj.exam_mark_grade === null) {
            // if mark score is not equal to null
            if (newObj.exam_mark_score !== null) {
              return newObj.exam_mark_score
            } else {
              const absent = '--'
              return absent
            }

            // return newObj.exam_mark_score
          } else {
            return newObj.exam_mark_grade
          }
        }
      } else {
        const noDatafound = '--'
        return noDatafound
      }
    },
    getMarksColor(marksArray, subjeectId) {
      // console.log("marks", marksArray)
      var foundValue = marksArray.filter(obj => obj.subject_id === subjeectId)
      // const y = find(x ["subject_id", u])
      if (foundValue.length !== 0) {
        // var mapped = foundValue.map(item => ({ [item.exam_mark_score]: item.subject_id }))
        var newObj = Object.assign({}, ...foundValue)
        // console.log(newObj);
        if (newObj.is_absent === 1) {
          return 'text-danger'
        } else {
          if (newObj.is_failed === 1) {
            return 'text-danger'
          } else {
            return 'text-dark'
          }
        }
      } else {
        return 'text-danger'
      }
    },
    // getStudentSubjectMark(subjectId) {
    //   return find(this.studentMarks, { subject_id: subjectId })
    // },
    print() {
      this.$htmlToPaper('examResultSingle')
    },
  },
}
</script>
